import { Component, EventEmitter, Output } from '@angular/core';
import { ChatAssistanceService } from '@commons/chat-assistance/chat-assistance.service';

import { ActiveRoom } from '../../model/active-room';

@Component({
  selector: 'chat-copy-layer',
  templateUrl: 'chat-copy-layer.component.html',
  styleUrls: ['./chat-copy-layer.component.scss'],
})
export class ChatCopyLayerComponent {
  public activeRoomList: ActiveRoom[] = [];

  @Output()
  copyToRoom: EventEmitter<any> = new EventEmitter();

  constructor(public readonly chatAssistanceService: ChatAssistanceService) {
    this.chatAssistanceService.loadRooms();
    this.activeRoomList = this.chatAssistanceService.getActiveRooms();
  }

  onCopyToRoom(roomId: string = ''): void {
    if (this.copyToRoom) {
      this.copyToRoom.emit(roomId);
    }
  }

  copyItemLabel(room: ActiveRoom): string {
    return room.toGuests.map(guest => `${guest.firstName} ${guest.lastName}`).join(',');
  }
}
